import HeroSection from "./components/HeroSection";
import TabSwitch from "../../../components/Switch/TabSwitch/TabSwitch";
import {Navigate, Route, Routes, useLocation, useNavigate} from "react-router-dom";
import Vip from "./vip/vip";

export default function PricingIndex({className, ...props}) {
    const navigate = useNavigate();

    function getSelectedTabFromPath() {
        let path = window.location.pathname.split("/").pop();
        return path === "pricing" ? "vip" : path;
    }


    function onTabChange(value) {
        navigate(`/pricing/${value}`);
    }


    return (
        <div className={` ${className}`}>
            <HeroSection/>
            <div className={"main px-8 lg:px-[7rem] mt-10 flex py-2  flex-col"}>

                <div className={"flex justify-center items-center w-full"}>
                    <TabSwitch options={[
                        {
                            label: "VIP",
                            value: "vip",
                        }
                        // , {
                        //     label: "Service",
                        //     value: "service",
                        // }
                    ]}
                               defaultSelected={getSelectedTabFromPath()}
                               onOptionChange={onTabChange} className={"mt-4"}/>
                </div>
            </div>

            <Routes>
                <Route path={"/vip"} element={<Vip/>}/>
                {/*<Route path={"/service"} element={<Service/>}/>*/}
                <Route path={"*"} element={<Navigate to={"/pricing/vip"}/>}/>
            </Routes>

        </div>

    )
}